import React from 'react';
import { Badge } from '../../../PageElements/Badge';
import style from './changelogPimple.scss';
import { NotificationIcon } from '../../../PageElements/svgs';

export const ChangelogPimple = ({ className }) => (
  <span>
    <NotificationIcon data-hook="changelog-pimple" className={className} />
  </span>
);

export const ChangelogBadge = () => (
  <Badge
    color="#ea5f0e"
    dataHook="changelog-badge"
    className={style.notificationBadge}
  >
    Updated
  </Badge>
);
